export const getters = {
  driverLogs(state) {
    return state.driverLogs;
  },
  driverLog(state, driverId) {
    return state.driverLogs[driverId];
  },
};
